import{BaseAlgoliaSearchService as e}from"./base-algolia-search-service.js";class s extends e{}export{s as AlgoliaSearchService};
